export const environment = {
    production: true,
    baseHref: '/SanCarlosZoning',
    apiBase: 'https://mydashgis.com/SanCarlosZoning',
    debug: true,
};

// export const environment = {
    // production: true,
    // baseHref: '',
    // apiBase: 'https://gis.cityofsancarlos.org',
    // debug: true,
// };